import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { APP_VERSION_INFO, provideFramework, ServingEnvironment, DATA_GEN_CONTRIBUTIONS, provideEntityViewRegistry } from '@optima-stride-ai/optima-app-framework';
import { BenzaitenDataGenPanelComponent } from './system-data-gen/benzaiten-data-gen-panel.component';
import { benzaitenEntityViewRegistry } from './entity-view/registry/benzaiten-entity-view-registry';
import { provideHttpClient } from '@angular/common/http';
import { provideOptimaUI } from '@optima-stride-ai/optima-components';
import Lara from '@primeuix/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { environment } from './environments/environment';
import packageJson from '../../package.json';
import { AdvancedMathService } from '@optima-stride-ai/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideFramework({
      // defaultAppId: environment.appId,
      servingEnvironment: environment.appEnvironment || ServingEnvironment.prod,
      subdomain: environment.subdomain,
      appId: environment.appId,
      debug: true,
      platform:{
        api:{
          baseURL: environment.benzaiten.appServer.baseURL,
          ext: environment.benzaiten.appServer.extension,
          version: environment.benzaiten.appServer.version
        }
      },
      enablePlatformBootstrap: true
    }),

    // ═══════════════════════════════════════════════════════════
    // APP VERSION INFO - For Settings > About section
    // ═══════════════════════════════════════════════════════════
    {
      provide: APP_VERSION_INFO,
      useValue: {
        appName: environment.displayName,
        appVersion: packageJson.version || '0.0.0',
        apiVersion: environment.benzaiten.appServer.version,
        optimaCoreVersion: packageJson.dependencies['@optima-stride-ai/core'],
        optimaFrameworkVersion: packageJson.dependencies['@optima-stride-ai/optima-app-framework'],
        optimaComponentsVersion: packageJson.dependencies['@optima-stride-ai/optima-components'],
        optimaPlatformVersion: packageJson.dependencies['@optima-stride-ai/optima-platform'],
      }
    },

    provideOptimaUI({ providePrime: true,
      themePreset: Lara
     }),
    // Override PrimeNG theme to prevent OS dark mode from being applied automatically.
    // Without this, `@primeuix/styled` defaults to darkModeSelector:"system" which
    // maps to @media (prefers-color-scheme: dark) - causing all PrimeNG components
    // (including p-treetable) to render with dark/black styles on devices that have
    // OS dark mode enabled.
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false
        }
      }
    }),
    AdvancedMathService,

    // ═══════════════════════════════════════════════════════════
    // ENTITY VIEW COMPONENT REGISTRY
    // appFrameworkRegistry is already provided by provideFramework() above; only register Benzaiten's own app-specific views here.
    // ═══════════════════════════════════════════════════════════
    provideEntityViewRegistry(benzaitenEntityViewRegistry),

    // ═══════════════════════════════════════════════════════════
    // DATA GENERATION CONTRIBUTIONS
    // Registers the Benzaiten data-gen panel with the framework's
    // Settings > Data Generation route (dev / uat only).
    // ═══════════════════════════════════════════════════════════
    {
      provide: DATA_GEN_CONTRIBUTIONS,
      useValue: {
        appName: environment.appName,
        displayName: environment.displayName,
        routePath: 'benzaiten',
        icon: 'cilTask',
        component: BenzaitenDataGenPanelComponent,
        hiddenSeededData: true, // Set to true to hide the "Seed with default data" button in the UI, since our panel handles seeding as part of its generation process.
      },
      multi: true,
    },
  ]
};
